import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// import Homepage from "./pages/Homepage";
import Sau from "./pages/sau/index";
import Showdoc from "./pages/sau/Showdoc";
import Showmedia from "./pages/sau/Showmedia";
import Showgame from "./pages/sau/Showgame";
import Showscopus from "./pages/sau/Showscopus";
import BingoPage1 from "./pages/sau/BingoPage1";
import BingoPage2 from "./pages/sau/BingoPage2";

import Login from "./pages/sau/Login";
import Manage from "./pages/sau/Manage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Sau />} />
        <Route path="/doc" element={<Showdoc />} />
        <Route path="/media" element={<Showmedia />} />
        <Route path="/game" element={<Showgame />} />
        <Route path="/login" element={<Login />} />
        <Route path="/manage" element={<Manage />} />
        <Route path="/scopus" element={<Showscopus />} />
        <Route path="/bingo1" element={<BingoPage1 />} />
        <Route path="/bingo2" element={<BingoPage2 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
